import BaseAPI from '@/services/api/internal/tools/baseAPI';

const PropertiesApi = new BaseAPI({
  url: `heating_ignition/api/v1/properties`,
});

// const PropertiesApi = new BaseAPI({
//   url: `http://localhost:3000/properties`,
// });

export default PropertiesApi;
